import bluebird from 'bluebird';
import accountApiClient from 'api/accountApiClient';
import leadsApiClient from 'api/leadsApiClient';

export enum FormSubmitStatus {
  INITIAL = 'initial',
  REQUESTED = 'requested',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

// ------------------------------------
// Action Types
// ------------------------------------
export const mandatoryFieldsActionTypes = {
  FETCH_REQUESTED: 'FETCH_MANDATORY_FIELDS_REQUESTED',
  FETCH_SUCCEEDED: 'FETCH_MANDATORY_FIELDS_SUCCEEDED',
  FETCH_FAILED: 'FETCH_MANDATORY_FIELDS_FAILED',
};

export const formActionTypes = {
  FORM_SUBMIT_REQUESTED: 'FORM_SUBMIT_REQUESTED',
  FORM_SUBMIT_SUCCEEDED: 'FORM_SUBMIT_SUCCEEDED',
  FORM_SUBMIT_FAILED: 'FORM_SUBMIT_FAILED',
};

// ------------------------------------
// Action Creators
// ------------------------------------

// Mandatory Contact Request Fields
export const fetchMandatoryFieldsRequest = () => ({
  type: mandatoryFieldsActionTypes.FETCH_REQUESTED,
});

export const fetchMandatoryFieldsSuccess = (mandatoryFields: any) => ({
  type: mandatoryFieldsActionTypes.FETCH_SUCCEEDED,
  mandatoryFields,
});

export const fetchMandatoryFieldsFailure = (status: any) => ({
  type: mandatoryFieldsActionTypes.FETCH_FAILED,
  httpStatus: status,
});

export const fetchMandatoryFields = (cwid: string) => (dispatch: any) =>
  bluebird
    .try(() => dispatch(fetchMandatoryFieldsRequest()))
    .then(() => accountApiClient.fetchRealtorMandatoryFields(cwid))
    .tap((mandatoryFields: any) => {
      return dispatch(fetchMandatoryFieldsSuccess(mandatoryFields));
    })
    .tapCatch((error: any) => {
      return dispatch(fetchMandatoryFieldsFailure(error.response.status));
    });

export const formSubmitRequest = () => (dispatch: any) =>
  dispatch({
    type: formActionTypes.FORM_SUBMIT_REQUESTED,
  });

export const formSubmitSuccess = () => ({
  type: formActionTypes.FORM_SUBMIT_SUCCEEDED,
});

export const formSubmitFailure = () => ({
  type: formActionTypes.FORM_SUBMIT_FAILED,
});

export const formSubmit = (formData: any, cwid: string) => (dispatch: any) => {
  const { address, zipcode, ...userInputs } = formData;
  return bluebird
    .try(() =>
      leadsApiClient.createContactRequest({
        ...userInputs,
        addressLine: address,
        zipCode: zipcode,
        accountCwid: cwid,
      }),
    )
    .tap(() => {
      return dispatch(formSubmitSuccess());
    })
    .catch(() => dispatch(formSubmitFailure()));
};

// ------------------------------------
// Form Reducer
// ------------------------------------
const INITIAL_STATE = {};
export const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case mandatoryFieldsActionTypes.FETCH_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };
    case mandatoryFieldsActionTypes.FETCH_SUCCEEDED:
      return {
        ...state,
        mandatoryFields: action.mandatoryFields,
        formSubmitted: false,
        formSubmitStatus: FormSubmitStatus.INITIAL,
        isLoading: false,
      };
    case mandatoryFieldsActionTypes.FETCH_FAILED:
      return {
        httpStatus: action.httpStatus,
        isLoading: false,
      };
    case formActionTypes.FORM_SUBMIT_REQUESTED:
      return {
        ...state,
        formSubmitStatus: FormSubmitStatus.REQUESTED,
      };
    case formActionTypes.FORM_SUBMIT_SUCCEEDED:
      return {
        ...state,
        formSubmitted: true,
        formSubmitStatus: FormSubmitStatus.SUCCESS,
      };
    case formActionTypes.FORM_SUBMIT_FAILED:
      return {
        ...state,
        formSubmitted: true,
        formSubmitStatus: FormSubmitStatus.FAILURE,
      };
    default:
      return state;
  }
};
